import React, { Component } from "react"
import { Form, Button, Card, Icon } from "semantic-ui-react"
import { Formik } from "formik"
import { Link, withRouter } from "react-router-dom"
import InputMask from "react-input-mask"
import { connect } from "react-redux"
import firebase from "../config/firebaseConfig"
import { toRecover, onRecover, getNumber, phoneRecover } from "../ducks/profile"
import { showMessage } from "../ducks/alerts"
import { string, boolean, ref, object } from "yup"
import { withTranslation } from "react-i18next"

@withTranslation()
@withRouter
@connect(
  (state) => ({
    profile: state.profile,
    alerts: state.alerts,
    phoneNumber: state.profile.phoneNumber,
  }),
  (dispatch) => ({
    toRecover: (data) => dispatch(toRecover(data)),
    phoneRecover: (data, redirect) => dispatch(phoneRecover(data, redirect)),
    showMessage: (m, t) => dispatch(showMessage(m, t)),
    getNumber: (data) => dispatch(getNumber(data)),
  }),
)
class RecoverPage extends Component {
  state = {
    step: 1,
    login: "",
    phone: "",
    pass: "",
    pass2: "",
    code: "",
    loading: false,
    icon: false,
    show: false,
    getNumberBtn: false,
    sendPwdBtn: true,
    clickable: true,
  }

  componentDidMount() {
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier("captcha", {
      size: "invisible",
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.phoneNumber) {
      if (
        prevProps.phoneNumber === null &&
        prevProps.phoneNumber !== this.props.phoneNumber
      ) {
        this.setState({
          getNumberBtn: true,
        })
        const { t } = this.props
        let number = "+7" + this.props.phoneNumber
        let appVerifier = window.recaptchaVerifier
        firebase
          .auth()
          .signInWithPhoneNumber(number, appVerifier)
          .then((confirmationResult) => {
            window.confirmationResult = confirmationResult
            this.props.showMessage(
              t("Password sent to the specified number"),
              "success",
            )
            this.setState({ step: 2 })
          })
          /* eslint handle-callback-err: "error" */
          .catch((error) => this.props.showMessage(error.message, "error"))
      }
    }
  }

  nextStep = () => {
    // this.setState({
    //   clickable: false,
    // })
    const { getNumber } = this.props
    const myObj = {
      login: this.state.login,
      bin: this.state.bin,
    }
    getNumber(myObj)
    // const data = {
    //   login: this.state.login,
    //   bin: this.state.login,
    // }
    // const { toRecover } = this.props
    // toRecover(data)
  }

  prevStep = () => {
    // this.setState({ step: 1 })
    location.reload()
  }

  handleChange = (e) => {
    const { t } = this.props
    const { showMessage } = this.props
    this.setState({
      [e.target.id]: e.target.value,
    })
    if (e.target.id === "code") {
      if (e.target.value.length === 6) {
        this.setState({
          loading: true,
        })
        window.confirmationResult
          .confirm(e.target.value)
          .then((result) => {
            this.setState({
              loading: false,
              icon: true,
              show: true,
              sendPwdBtn: false,
            })
          })
          .catch(function(error) {
            showMessage(t("Incorrect code entered"), "error")
          })
      }
    }
  }

  onSubmit = ({ pass, pass2 }) => {
    const data = {
      bin: this.state.login,
      pwd: pass,
      pw2: pass2,
    }
    const { phoneRecover } = this.props
    phoneRecover(data, this.props)
  }

  render() {
    const { t } = this.props
    const {
      step,
      login,
      pass,
      pass2,
      code,
      show,
      getNumberBtn,
      sendPwdBtn,
      clickable,
    } = this.state

    const values = {
      code: code,
      pass: pass,
      pass2: pass2,
    }

    const validationSchema = object({
      pass: string(t("Enter code")).required(t("requiredField")),
      pass2: string(t("Enter code")).required(t("requiredField")),
    })
    return (
      <>
        {step === 1 ? (
          <div className="login-page-holder">
            <Card fluid className="login-page">
              <Card.Content>
                <div className="login-page-title">
                  <div className="flipper-container">
                    <div className="flipper flipper-front">
                      <img
                        className="login-page-img"
                        src={require(`../assets/img/logo.png`)}
                      />
                    </div>
                    <div className="flipper flipper-back">
                      <div className="login-page-spinner">
                        <div className="spinner">
                          <div className="rect1" />
                          <div className="rect2" />
                          <div className="rect3" />
                          <div className="rect4" />
                          <div className="rect5" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <h2>{t("Password recovery")}</h2>
                </div>

                <div className="login-page-form">
                  <Form>
                    <Form.Field>
                      <InputMask
                        mask="999999999999"
                        onChange={this.handleChange}
                        value={login}
                      >
                        {(inputProps) => (
                          <Form.Input
                            name="login"
                            label={t("Login/IIN")}
                            id="login"
                            placeholder={t("Login/IIN")}
                            // onChange={this.handleChange}
                            // value={login}
                            type="text"
                          />
                        )}
                      </InputMask>
                    </Form.Field>
                    <Button
                      style={{ marginTop: 15 }}
                      content={t("back")}
                      color="green"
                      as={Link}
                      to="/"
                    />
                    <Button
                      style={{ marginTop: 15 }}
                      content={t("next")}
                      color="green"
                      id="captcha"
                      disabled={login === "" || getNumberBtn || !clickable}
                      onClick={this.nextStep}
                    />
                  </Form>

                  {/* <>
                    <Button
                      style={{ marginTop: 15 }}
                      content="Назад"
                      color="green"
                      as={Link}
                      to="/"
                    />
                    <Button
                      style={{ marginTop: 15 }}
                      content="Далее"
                      color="green"
                      id="captcha"
                      disabled={login === "" || getNumberBtn || !clickable}
                      onClick={this.nextStep}
                    />
                  </> */}
                </div>
              </Card.Content>
            </Card>
          </div>
        ) : (
          <div className="login-page-holder">
            <Card fluid className="login-page">
              <Card.Content>
                <div className="login-page-title">
                  <div className="flipper-container">
                    <div className="flipper flipper-front">
                      <img
                        className="login-page-img"
                        src={require(`../assets/img/logo.png`)}
                      />
                    </div>
                    <div className="flipper flipper-back">
                      <div className="login-page-spinner">
                        <div className="spinner">
                          <div className="rect1" />
                          <div className="rect2" />
                          <div className="rect3" />
                          <div className="rect4" />
                          <div className="rect5" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <h2>{t("Password recovery")}</h2>
                </div>
                <Formik
                  render={(props) => (
                    <>
                      <Form onSubmit={props.handleSubmit}>
                        <Form.Input
                          label="Код"
                          loading={this.state.loading}
                          // disabled={this.state.loading}
                          icon={
                            this.state.icon && (
                              <Icon name="check" color="green" />
                            )
                          }
                          name="code"
                          id="code"
                          placeholder="Код"
                          onChange={this.handleChange}
                          value={code}
                          type="text"
                          autoFocus
                        />
                        <p
                          style={{
                            fontSize: "13px",
                            marginTop: "-15px",
                            color: "grey",
                          }}
                        >
                          * {t("Enter the code sent to your number")}
                        </p>
                        {show ? (
                          <>
                            <Form.Input
                              label="Пароль"
                              error={props.errors.pass}
                              name="pass"
                              id="pass"
                              placeholder="Пароль"
                              onChange={props.handleChange}
                              value={props.values.pass}
                              type="password"
                            />
                            <Form.Input
                              label={t("Confirm password")}
                              error={props.errors.pass2}
                              name="pass2"
                              id="pass2"
                              placeholder="Пароль"
                              onChange={props.handleChange}
                              value={props.values.pass2}
                              type="password"
                            />
                          </>
                        ) : null}
                      </Form>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <Button
                          style={{ marginTop: 15 }}
                          content={t("back")}
                          color="green"
                          onClick={this.prevStep}
                        />
                        <Button
                          style={{ marginTop: 15 }}
                          onClick={props.handleSubmit}
                          color="green"
                          disabled={sendPwdBtn}
                        >
                          {t("toComplete")}
                        </Button>
                      </div>
                    </>
                  )}
                  validationSchema={validationSchema}
                  initialValues={values}
                  onSubmit={this.onSubmit}
                />
              </Card.Content>
            </Card>
          </div>
        )}
      </>
    )
  }
}

export default RecoverPage
